import { createFileRoute } from "@tanstack/react-router";
import DrDanielPietras from "@/pages/DrDanielPietras";
export const Route = createFileRoute("/dr-daniel-pietras-md")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Dr. Daniel Pietras, MD | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Dr. Daniel Pietras, MD, Medical Director at Neuro Wellness TMS. Board-certified psychiatrist specializing in TMS and treatment-resistant depression in Coral.",
        },
        {
          property: "og:title",
          content: "Dr. Daniel Pietras, MD | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Dr. Daniel Pietras, MD, Medical Director at Neuro Wellness TMS. Board-certified psychiatrist specializing in TMS and treatment-resistant depression in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/dr-daniel-pietras-md",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/dr-daniel-pietras-md",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DrDanielPietras />;
}
